<template>
  <div class="container-fluid pb-4">
    <div class="row">
      <nav v-if="user" class="navbar navbar-dark bg-dark navbar-expand-lg navbar-light w-100">
        <!-- brand -->
        <router-link to="/" v-slot="{ href, navigate }"
          ><a class="navbar-brand px-3" :href="href" @click="navigate"><img src="@/assets/images/logo-wide-white.png"/></a
        ></router-link>

        <!-- toggle -->
        <button
          class="navbar-toggler"
          type="button"
          data-toggle="collapse"
          data-target="#navbarNavAltMarkup"
          aria-controls="navbarNavAltMarkup"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span class="navbar-toggler-icon"></span>
        </button>

        <div class="collapse navbar-collapse" id="navbarNavAltMarkup">
          <!-- links left -->
          <div class="navbar-nav mr-auto">
            <div v-for="link in links" :key="link.href">
              <router-link :to="link.href" v-slot="{ href, isActive, navigate }">
                <a class="nav-item nav-link" :class="isActive ? 'active' : ''" :href="href" @click="navigate">{{ link.text }}</a>
              </router-link>
            </div>
          </div>
          <!-- links right -->
          <button
            class="btn btn-outline-light shadow-none text-right mr-3"
            type="button"
            data-toggle="modal"
            data-target="#helpVideoModal"
            aria-haspopup="true"
            aria-expanded="false"
          >
            <fa icon="question" />
          </button>
          <div class="modal fade" id="helpVideoModal" tabindex="-1" role="dialog" aria-labelledby="helpVideoModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-dialog-scrollable" role="document">
              <div class="modal-content">
                <div class="modal-header">
                  <h5 class="modal-title" id="helpVideoModalLabel">Help Center</h5>
                  <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                </div>
                <div class="modal-body">
                  <div class="list-group">
                    <a href="/help/video/v/780779709?h=baa6e3bc3a" target="_blank" class="list-group-item list-group-item-action">
                      <div class="d-flex w-100 justify-content-between">
                        <h5 class="mb-1">Verensics Best Practices</h5>
                      </div>
                      <p class="mb-1">How to successfully use the Verensics platform.</p>
                    </a>
                    <a href="/help/video/y/q6WCmJtLLLM" target="_blank" class="list-group-item list-group-item-action">
                      <div class="d-flex w-100 justify-content-between">
                        <h5 class="mb-1">How to Start Interviewing</h5>
                      </div>
                      <p class="mb-1">This video instructs you how to start an interview, whether remotely or at your facility.</p>
                    </a>
                    <a href="/help/video/v/858025848?h=543a11dee6" target="_blank" class="list-group-item list-group-item-action">
                      <div class="d-flex w-100 justify-content-between">
                        <h5 class="mb-1">Creating an Investigation</h5>
                      </div>
                      <p class="mb-1">
                        This video explains how to open investigations and add interviews to an investigation.
                      </p>
                    </a>
                    <a href="/help/video/y/1AW0Tsc_5w8" target="_blank" class="list-group-item list-group-item-action">
                      <div class="d-flex w-100 justify-content-between">
                        <h5 class="mb-1">How to Edit Your Organization and Users</h5>
                      </div>
                      <p class="mb-1">
                        This video instructs you how to edit your organization's characteristics, including adding and editing your organization's users.
                      </p>
                    </a>
                    <a href="/help/video/v/811384639?h=a71a40656a" target="_blank" class="list-group-item list-group-item-action">
                      <div class="d-flex w-100 justify-content-between">
                        <h5 class="mb-1">Dashboard Overview</h5>
                      </div>
                      <p class="mb-1">
                        This video instructs you in all of the functions and tools on the reports dashboard.
                      </p>
                    </a>
                    <a href="/help/video/v/811378367?h=3a8006d428" target="_blank" class="list-group-item list-group-item-action">
                      <div class="d-flex w-100 justify-content-between">
                        <h5 class="mb-1">Viewing Reports</h5>
                      </div>
                      <p class="mb-1">
                        This video explains how to access/interpret/edit reports and describes all of the functionality and charts in the reports.
                      </p>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="dropdown" v-if="user">
            <button class="btn btn-outline-light shadow-none text-right" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
              <fa icon="user" />
            </button>
            <div class="dropdown-menu dropdown-menu-right mt-2">
              <!-- user -->
              <div v-if="organization">
                <h6 class="dropdown-header">User</h6>
                <router-link :to="`/organizations/${organization.id}/users/${user.id}`" v-slot="{ href, navigate }">
                  <a class="dropdown-item" :href="href" @click="navigate">{{ user.emailAddress }}</a>
                </router-link>
                <div class="dropdown-divider"></div>
              </div>
              <!-- organization -->
              <div v-if="organization">
                <h6 class="dropdown-header">Organization</h6>
                <p v-if="!isOrganizationAdministrator" class="py-1 px-4">{{ organization.displayName }}</p>
                <router-link v-if="isOrganizationAdministrator" :to="`/organizations/${organization.id}`" v-slot="{ href, navigate }">
                  <a class="dropdown-item" :href="href" @click="navigate">{{ organization.displayName }}</a>
                </router-link>
                <div class="dropdown-divider"></div>
              </div>
              <!-- sign out -->
              <router-link to="/signout" v-slot="{ href, navigate }">
                <a class="dropdown-item" :href="href" @click="navigate">Sign Out</a>
              </router-link>
            </div>
          </div>
        </div>
      </nav>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  computed: {
    ...mapGetters("organization", ["organization"]),
    ...mapGetters("user", ["user"]),
    ...mapGetters("role", [
      "isVerensicsAdministrator",
      "isOrganizationAdministrator",
      "isReportSummary",
      "isReportViewer",
      "isReportCreator",
      "isInvestigationSummary",
      "isInvestigationViewer",
      "isInvestigationCreator",
    ]),
    ...mapGetters("feature", ["hasReports", "hasInvestigations"]),
    links() {
      var links = [];

      if (this.isVerensicsAdministrator) {
        links.push({ text: "Organizations", href: "/organizations" });
      }

      if (this.hasReports && (this.isReportSummary || this.isReportCreator || this.isReportViewer)) {
        links.push({ text: "Reports", href: `/organizations/${this.organization.id}/reports` });
      }

      if (
        this.hasInvestigations &&
        (this.isOrganizationAdministrator || this.isInvestigationSummary || this.isInvestigationCreator || this.isInvestigationViewer)
      ) {
        links.push({ text: "Investigations", href: `/organizations/${this.organization.id}/investigations` });
      }

      if (this.hasReports && this.isReportCreator) {
        links.push({ text: "Create", href: `/organizations/${this.organization.id}/reports/create` });
      }

      if (this.isOrganizationAdministrator) {
        links.push({ text: "Users", href: `/organizations/${this.organization.id}/users` });
      }

      if (this.isVerensicsAdministrator) {
        links.push({ text: "Admin", href: "/admin" });
      }

      return links;
    },
  },
};
</script>

<style lang="scss" scoped>
.navbar-brand {
  overflow: hidden;
  margin-right: 0;

  img {
    height: 60px;
    margin-top: -30px;
    margin-bottom: -24px;
    margin-left: -30px;
    margin-right: -10px;
  }
}

.navbar-text {
  cursor: default;
}

.modal-dialog {
  position: fixed;
  margin: auto;
  width: 360px;
  height: 75%;
  top: 56px;
  right: 0px;
}
</style>
